import { render } from "./WeightBlock.vue?vue&type=template&id=c087dc20&ts=true"
import script from "./WeightBlock.vue?vue&type=script&lang=ts"
export * from "./WeightBlock.vue?vue&type=script&lang=ts"

import "./WeightBlock.vue?vue&type=style&index=0&id=c087dc20&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__